import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { supabase } from "./supabaseClient";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const GHOST_ID = 13;
// turn "SPOT 17 EV" into 17 (fallback to id)
const getNum = (s) => {
  const m = (s?.name || "").match(/\d+/);
  return m ? parseInt(m[0], 10) : s.id;
};


export default function MapView() {
  const [spots, setSpots] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [pricing, setPricing] = useState([]);

  useEffect(() => {
    fetchSpots();
    fetchPricing();
  }, []);

  useEffect(() => {
    if (startDate) fetchReservations();
  }, [startDate, endDate]);

async function fetchSpots() {
  const { data } = await supabase.from("spots").select("*").neq("id", 13);

  // sort numerically by the number in the name
  const sorted = (data || []).sort((a, b) => getNum(a) - getNum(b));

  // keep using the existing `spots` state
  setSpots(sorted);
}





  async function fetchReservations() {
  const start = dayjs(startDate).format("YYYY-MM-DD");
  const end = endDate ? dayjs(endDate).format("YYYY-MM-DD") : start;

  const { data } = await supabase
    .from("reservations")
    .select("*")
    .lte("start_date", end)
    .gte("end_date", start)
    .neq("spot_id", GHOST_ID);

  setReservations(data || []);
}


  async function fetchPricing() {
    const { data } = await supabase.from("pricing").select("*");
    setPricing(data || []);
  }

  function generateDateRange(start, end) {
    const dates = [];
    let current = dayjs(start);
    const endObj = dayjs(end);
    while (current.isSame(endObj) || current.isBefore(endObj)) {
      dates.push(current);
      current = current.add(1, "day");
    }
    return dates;
  }

  function getPriceFor(month, type) {
    const match = pricing.find((p) => p.month === month && p.type === type);
    return match?.price_per_day || 0;
  }

  const reservedSpotIds = reservations.map((r) => r.spot_id);

  const reservationLookup = {};
  reservations.forEach((r) => {
    const spotId = r.spot_id;
    let current = dayjs(r.start_date);
    const end = dayjs(r.end_date);
    while (current.isSame(end) || current.isBefore(end)) {
      const key = `${spotId}-${current.format("YYYY-MM-DD")}`;
      reservationLookup[key] = r;
      current = current.add(1, "day");
    }
  });

// make the two columns from the sorted `spots`
const leftSpots = (spots || []).filter((s) => getNum(s) <= 10);
const rightSpots = (spots || []).filter((s) => getNum(s) > 10);


  return (
    <div style={{ padding: 20 }}>
      <h1>Parking Ground Map</h1>

      {/* Container Flex */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 20,
          alignItems: "flex-start",
        }}
      >
        {/* Calendar Section */}
        <div style={{ flex: "1 1 300px", minWidth: "280px" }}>
          <Calendar
            onClickDay={(value) => {
              if (!startDate || (startDate && endDate)) {
                setStartDate(value);
                setEndDate(null);
              } else if (startDate && !endDate) {
                if (value < startDate) {
                  setEndDate(startDate);
                  setStartDate(value);
                } else {
                  setEndDate(value);
                }
              }
            }}
            value={startDate && endDate ? [startDate, endDate] : startDate}
            selectRange={true}
          />
          <h2>
            {startDate && !endDate && dayjs(startDate).format("DD MMM YYYY")}
            {startDate &&
              endDate &&
              `${dayjs(startDate).format("DD MMM YYYY")} - ${dayjs(
                endDate
              ).format("DD MMM YYYY")}`}
          </h2>
          <p style={{ fontSize: "12px", color: "#666", marginTop: "10px" }}>
            Select a start and end date to view reservations for that period.
          </p>
        </div>

        {/* Map Section */}
        <div
          style={{
            position: "relative",
            flex: "1 1 300px",
            minWidth: "300px",
            height: "800px",
            border: "2px solid black",
            backgroundColor: "#eaeaea",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: "50%",
              top: 0,
              width: "120px",
              height: "100%",
              transform: "translateX(-50%)",
              backgroundColor: "#d0d0d0",
            }}
          ></div>

         {/* Left spots: 1–10 */}
{leftSpots.map((spot, index) => (
  <div
    key={spot.id}
    style={{
      position: "absolute",
      top: 20 + index * 70,
      left: 20,
      width: 100,
      height: 60,
      backgroundColor: reservedSpotIds.includes(spot.id)
        ? "tomato"
        : "lightgreen",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 4,
      cursor: "pointer",
      fontWeight: "bold",
    }}
  >
    {spot.name}
  </div>
))}

{/* Right spots: 11–20 */}
{rightSpots.map((spot, index) => (
  <div
    key={spot.id}
    style={{
      position: "absolute",
      top: 20 + index * 70,
      right: 20,
      width: 100,
      height: 60,
      backgroundColor: reservedSpotIds.includes(spot.id)
        ? "tomato"
        : "lightgreen",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 4,
      cursor: "pointer",
      fontWeight: "bold",
    }}
  >
    {spot.name}
  </div>
))}


          {/* Entrance */}
          <div
            style={{
              position: "absolute",
              bottom: -30,
              left: 20,
              fontWeight: "bold",
            }}
          >
            Entrance
          </div>
        </div>
      </div>

      {/* Reservation Table */}
      {startDate && endDate && (
        <div style={{ marginTop: 60, overflowX: "auto" }}>
          <h2>Reservation Grid</h2>
          <table
            border="1"
            cellPadding="5"
            style={{
              borderCollapse: "collapse",
              width: "100%",
              fontSize: "14px",
              minWidth: "600px",
            }}
          >
            <thead>
              <tr>
                <th style={{ backgroundColor: "#7ac943", color: "white" }}>
                  Parking
                </th>
                {generateDateRange(startDate, endDate).map((date) => (
                  <th key={date}>
                    {date.format("D MMM")}
                    <br />
                    <span style={{ fontWeight: "normal", fontSize: "12px" }}>
                      client / price
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {spots.map((spot) => (
                <tr key={spot.id}>
                  <td
                    style={{
                      backgroundColor: "#7ac943",
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    {spot.name}
                  </td>
                  {generateDateRange(startDate, endDate).map((date) => {
                    const key = `${spot.id}-${date.format("YYYY-MM-DD")}`;
                    const r = reservationLookup[key];
                    let price = null;

                    if (r) {
                      const start = dayjs(r.start_date);
                      const end = dayjs(r.end_date);
                      const totalDays = end.diff(start, "day") + 1;

                      if (r.manual_override) {
                        price = Number(r.total_price) / totalDays;
                      } else {
                        price = getPriceFor(date.month() + 1, spot.type);
                      }
                    }

                    return (
                      <td
                        key={key}
                        style={{
                          backgroundColor: r ? "black" : "#eee",
                          color: r ? "white" : "#333",
                          textAlign: "center",
                        }}
                      >
                        {r ? (
                          <>
                            {r.reserved_by}
                            <br />
                            €{price.toFixed(2)}
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
